export default function getInstructionsManager() {
  let lastDisplayTime = 0;
  var maxDelay = 1000;

  function getMaxDelay() {
    return maxDelay;
  }

  function setMaxDelay(delay) {
    maxDelay = delay;
  }

  function showInstructions() {
    let d = new Date();
    let epoch = d.getTime();
    if (epoch >= lastDisplayTime + maxDelay) {
      lastDisplayTime = epoch;
      return true;
    } else {
      return false;
    }
  }

  function updateLastDisplayTime() {
    let d = new Date();
    let epoch = d.getTime();
    lastDisplayTime = epoch;
  }

  return Object.freeze({
    getMaxDelay,
    setMaxDelay,
    showInstructions,
    updateLastDisplayTime
  });
}
